import { EmployeeCountT, FundingRoundT } from "ui-io/company-io";
import { formatLargeNumber } from "ui-lib";

export { TABS } from "./constants";

export const reloadPage = () => {
  setTimeout(() => {
    window.location.reload();
  }, 500);
};
export const calculateFundingAmount = (fundingArray:FundingRoundT[]) => {
  return formatLargeNumber(fundingArray.reduce((total, entry) => total + entry.amount, 0));
};
export const getLatestEmployeeCount = (empArray:EmployeeCountT[]) => {
  const latestRecord = empArray.reduce((latest, current) => 
        parseInt(current.year) > parseInt(latest.year) ? current : latest
    );
    return latestRecord.count.to;
};
export const getInvestorCount = (fundingArray:FundingRoundT[]) => {
    const uniqueInvestors = new Set(fundingArray.flatMap(entry => entry.investorIDs));
    return uniqueInvestors.size;
};
